import { FC } from "react";

export const ArrowBack: FC = () => {
  return (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
  >
    <path
      fill="#343A40"
      d="m8.318 11.767 3.825 3.825a.833.833 0 1 0 1.175-1.184l-3.833-3.816a.834.834 0 0 1 0-1.184l3.833-3.816a.834.834 0 0 0-1.175-1.184L8.318 8.233a2.5 2.5 0 0 0 0 3.534Z"
    />
  </svg>
  );
};
